export interface HeritageImageCard {
  id: string;
  label: string;
  src: string;
  alt: string;
  gridArea: {
    colStart: number;
    colSpan: number;
    rowStart: number;
    rowSpan: number;
  };
  aspectRatio: string;
  offsetY?: number;
}

export interface AboutHeritageShowcaseContent {
  heading: string;
  description: string;
  images: HeritageImageCard[];
}

export const ABOUT_HERITAGE_SHOWCASE_CONTENT: AboutHeritageShowcaseContent = {
  heading: "Craftsmanship",

  description:
    "Every product we create is the result of skilled craftsmanship, thoughtful engineering, and uncompromising attention to detail. From handcrafted metalware and wooden décor to luxury furniture, marble, glass, resin, and mixed-material creations, we transform ideas into premium products that meet global quality standards and elevate brands worldwide.",

  images: [
    {
      id: "brass",
      label: "Brass",
      src: "/gallery/brassv2.webp",
      alt: "Skilled artisan handcrafting premium brass decor",
      gridArea: { colStart: 7, colSpan: 4, rowStart: 1, rowSpan: 2 },
      aspectRatio: "4 / 5",
      offsetY: 0,
    },
    {
      id: "wood",
      label: "Wood",
      src: "/categories/woodv2.webp",
      alt: "Handcrafted wooden furniture with fine detailing",
      gridArea: { colStart: 11, colSpan: 2, rowStart: 1, rowSpan: 1 },
      aspectRatio: "5 / 4",
      offsetY: 80,
    },
    {
      id: "marble",
      label: "Marble",
      src: "/categories/marblev2.webp",
      alt: "Luxury marble handcrafted home decor",
      gridArea: { colStart: 5, colSpan: 3, rowStart: 3, rowSpan: 1 },
      aspectRatio: "5 / 4",
      offsetY: 40,
    },
    {
      id: "metal",
      label: "Metal",
      src: "/categories/copperv2.webp",
      alt: "Precision metal manufacturing and finishing",
      gridArea: { colStart: 1, colSpan: 4, rowStart: 3, rowSpan: 2 },
      aspectRatio: "4 / 5",
      offsetY: 60,
    },
    {
      id: "custom",
      label: "Custom",
      src: "/categories/lightv211.webp",
      alt: "Custom handcrafted product development by expert artisans",
      gridArea: { colStart: 8, colSpan: 5, rowStart: 3, rowSpan: 2 },
      aspectRatio: "5 / 4",
      offsetY: 20,
    },
  ],
};

export const HERITAGE_COLORS = {
  filled: "#0a0a0a",
  faded: "#d6d3d1",
} as const;